export const sendForm = async (formData) => {

  return fetch('https://visitor.natu.care/feedback', {
    method: 'POST',
    body: formData
  });
};
